import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyrightShellComponent } from './copyright-shell/copyright-shell.component';



@NgModule({
  declarations: [CopyrightShellComponent],
  imports: [
    CommonModule
  ],
  exports:[CopyrightShellComponent]
})
export class CopyrightModule { }
